import { IAttachment } from "./attachment";
import { IDeviceDepotNavigator } from "./device-depot";
import { IDeviceLink } from "./device-link";
import { IDeviceStatus } from "./device-status";
import { ILocation } from "./location";
import { IMeasuringPointNavigator } from "./measuring-point";
import { IServiceModelBase } from "./servicemodelbase";
import { IVehicleConfiguration } from "./vehicle-configuration";
import { IWorkerBase } from "./worker";

export enum DeviceType {
    SigncoTablet = "signcoTablet",
    Vehicle = "vehicle",
    WJet = "wJet",
}

export interface IDeviceNavigator extends IServiceModelBase {
    code: string;
    typeId: DeviceType;
    ownerId: number;
}

export interface IDeviceSummary extends IDeviceNavigator {
    currentLocationId: number;
    description: string;
    manufacturer: string;
    measuringPoints: IMeasuringPointNavigator[];
    alarmsHigh: number[];
    alarmsLow: number[];
    cameraConfigurationImage: string;
    depot: IDeviceDepotNavigator;
}

export interface IDeviceFeatures {
    zigbee: boolean;
    gpio: boolean;
    otaUpdate: boolean;
    realtimeAnalyzer: boolean;
    vms: boolean;
    qLiteDisplay: boolean;
    dekimoDisplay: boolean;
    tmsRadar: boolean;
    simulateData: boolean;
}

export interface IDevice extends IServiceModelBase {
    id: number;
    code: string;
    description: string;
    manufacturer: string;
    typeId: DeviceType;
    features: IDeviceFeatures;
    ownerId: number;
    currentLink: IDeviceLink;
    currentStatus: IDeviceStatus;
    lastSync: Date;
    currentLocation: ILocation;
    isOffline: boolean;
    useRealtimeUpdates: boolean;
    batteryDischargeTableId: number;
    imei: string;
    ipAddress: string;
    qrCode: string;

    hardwareConfiguration: string;
    vehicleConfiguration: IVehicleConfiguration;

    workerDriver?: IWorkerBase;
    attachment?: IAttachment;
}

export class DeviceCreator {
    code: string;
    description: string;
    features: IDeviceFeatures;
    hardwareConfiguration: string;
    imei: string;
    ipAddress: string;
    isOffline: boolean;
    manufacturer: string;
    ownerId?: number;
    qrCode: string;
    typeId: DeviceType;
    useRealtimeUpdates: boolean;
    workerDriverId?: number;
}

export class DeviceUpdater extends DeviceCreator {
    constructor(existingDevice: IDevice) {
        super();

        this.id = existingDevice.id;
        this.code = existingDevice.code;
        this.description = existingDevice.description;
        this.manufacturer = existingDevice.manufacturer;
        this.typeId = existingDevice.typeId;
        this.features = existingDevice.features;
        this.ownerId = existingDevice.ownerId;
        this.isOffline = existingDevice.isOffline;
        this.imei = existingDevice.imei;
        this.hardwareConfiguration = existingDevice.hardwareConfiguration;
        this.useRealtimeUpdates = existingDevice.useRealtimeUpdates;
        this.vehicleConfiguration = existingDevice.vehicleConfiguration;

        this.workerDriverId = existingDevice.workerDriver?.id;
    }

    id: number;
    vehicleConfiguration: IVehicleConfiguration;
}

export interface IDeviceLastLocationsCompared {
    gpsLocation?: ILocation;
    gpsAddress?: string;
    timestampGps?: Date;
    linkedLocation?: ILocation;
    distanceInMeter?: number;
    cellTowerLocation?: ILocation;
    error: boolean;
}
